// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/forms/Blocks/Webinar_AIClaims.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/forms/Blocks/Webinar_AIClaims.tsx");
  import.meta.hot.lastModified = "1773385375628.0876";
}
// REMIX HMR END

import { Fragment } from "react";
import { HoneypotInputs } from "remix-utils/honeypot/react";
import { schema } from "~/routes/webinar.request";
import Form from "../Form";
const Errors = {
  EMAIL_REGISTERED: <Fragment>
      <p className="font-bold">We’ve already received your request.</p>
      <p>We’ll contact you as soon as possible.</p>
    </Fragment>,
  UNEXPECTED_ERROR: <Fragment>
      <p className="font-bold">Sorry, we couldn't send your request.</p>
      <p>Please try again or contact hq@octahedroid.com</p>
    </Fragment>
};
export default function Webinar_AICLaims({
  fetcher
}) {
  return <Form id="webinarForm" action="/webinar/request" hiddenFields={["campaign"]} buttonLabel="Submit" fetcher={fetcher} mode="onBlur" className="space-y-4 w-full flex flex-col items-center children:w-full" schema={schema} options={{
    role: [{
      name: "Select an option",
      value: "Select an option"
    }, {
      name: "C-Level",
      value: "C-Level"
    }, {
      name: "Director or Lead",
      value: "Director or Lead"
    }, {
      name: "Developer",
      value: "Developer"
    }, {
      name: "Marketing",
      value: "Marketing"
    }, {
      name: "Other",
      value: "Other"
    }],
    hearAbout: [{
      name: "Select an option",
      value: "Select an option"
    }, {
      name: "At an event",
      value: "At an event"
    }, {
      name: "By email",
      value: "By email"
    }, {
      name: "In a blog post",
      value: "In a blog post"
    }, {
      name: "On social media",
      value: "On social media"
    }, {
      name: "Someone mentioned it to me",
      value: "Someone mentioned it to me"
    }, {
      name: "Other",
      value: "Other"
    }]
  }}>
      {({
      Field,
      Button
    }) => <Fragment>
          <HoneypotInputs label="Please leave this field blank" />
          <Field name="campaign" type="hidden" value="webinar_aiclaims" />
          <Field name="name" label="Name" />
          <Field name="lastName" label="Last Name" />
          <Field name="email" label="Email" />
          <Field name="company" label="Company" />
          <Field name="role" label="What is your role?" />
          <Field name="hearAbout" label="Where did you hear about the webinar?" />
          {fetcher.data?.errors?._global && <div className="mt-4 text-center bg-error-600 p-4 text-white">
              {Errors[fetcher.data?.errors?._global]}
            </div>}
          <Button className="!w-fit justify-self-end ml-auto">Submit</Button>
        </Fragment>}
    </Form>;
}
_c = Webinar_AICLaims;
var _c;
$RefreshReg$(_c, "Webinar_AICLaims");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;